/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Network_Demand_HelpInputs */



/**
* | output |
* | --- |
* | "Average opening of connected th. heads on the network" |
*
* @param {Network_Demand_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_demand_help = /** @type {((inputs?: Network_Demand_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Demand_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Average opening of connected th. heads on the network")
	return /** @type {LocalizedString} */ ("Moyenne d'ouverture des têtes th. du réseau connectées")
});